import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import * as React from 'react';
import styled from 'styled-components';
import { Button } from '@ifixit/toolbox';
import { space } from '@core-ds/primitives';
import { _js } from '@ifixit/localize';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   margin-top: ", ";\n"])), space[5]);

var ReviewLink = function ReviewLink(_ref) {
  var reviewsUrl = _ref.reviewsUrl;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Button, {
    href: reviewsUrl,
    fullWidth: true,
    design: "primary"
  }, _js('Write a product review')));
};

export default ReviewLink;